import {useWaiver} from 'Event/Step2/Waivers/Waiver'
import styled from 'styled-components'
import {useTemplate} from 'Event/TemplateProvider'
import React from 'react'
import Grid from '@material-ui/core/Grid'
import Configurable from 'organization/Event/Configurable'
import SubmitButtonConfig from 'Event/Step2/Waivers/Waiver/SubmitButton/SubmitButtonConfig'
import {Button} from 'Event/Dashboard/components/NavButton'
import {useAttendeeVariables} from 'Event'

export default function SubmitButton() {
  const {canSubmit, submitting} = useWaiver()

  const v = useAttendeeVariables()

  const {
    waiver: {button, submittingText},
  } = useTemplate()

  return (
    <Box>
      <Grid item xs={button.size}>
        <Configurable>
          <SubmitButtonConfig />
          <StyledButton
            {...button}
            type="submit"
            disabled={!canSubmit}
            text={submitting ? v(submittingText) : v(button.text)}
          />
        </Configurable>
      </Grid>
    </Box>
  )
}

export const Box = styled.div`
  display: flex;
  justify-content: center;
`
export const StyledButton = styled(Button)`
  color: ${(props) => props.textColor};
`
